import { DeserializedAffiliation } from 'types';

export const serializeAffiliations = (affiliations: DeserializedAffiliation[]) =>
  affiliations.map(({ position, institution }) => ({
    academicTitle: position.label,
    institution: institution.label,
  }));
